/* tslint:disable:max-line-length */
import { DefaultMessages, SegmentSpecificMessages } from '@sheerid/jslib';

type ExtendedMessages = {
    locales: {
        'en-AU': string,
    },
    step: {
        personalInfo: {
            title: string,
        },
        success: {
            title: string,
            subtitle: string,
            redirectTextA: string,
            redirectTextB: string,
            buttonTwo: string,
            underCoupon: string,
        },
        docUpload: {
            title: string,
            subtitle: string,
        },
    },
};

export const medicalMessagesFrCA: DefaultMessages & SegmentSpecificMessages & ExtendedMessages = {
    birthDate : 'Date de naissance',
    branchOfService : 'Secteur de service',
    changeLanguage : 'Changer de langue',
    optIn: "J'aimerais recevoir des communications commerciales, y compris des courriel, de P.volve.",
    infoShared: 'Les informations fournies seront utilisées à des fins de vérification et partagées avec P.volve.',
    MedicalProfessionalInfoShared: 'Les informations saisies ici seront utilisées à des fins de vérification.',
    country : 'Pays',
    countryPlaceholder: 'Pays',
    statusPlaceholder: 'Statut',
    OTHER_HEALTH_WORKER: 'Autre agent de santé',
    DOCTOR: 'Docteur',
    NURSE: 'Infirmière',
    countries : {
        AD : 'Andorre',
        AE : 'Émirats arabes unis',
        AF : 'Afghanistan',
        AG : 'Antigua-et-Barbuda',
        AI : 'Anguilla',
        AL : 'Albanie',
        AM : 'Arménie',
        AN : 'Antilles néerlandaises',
        AO : 'Angola',
        AR : 'Argentine',
        AS : 'Samoa américaines',
        AT : 'Autriche',
        AU : 'Australie',
        AW : 'Aruba',
        AZ : 'Azerbaïdjan',
        BA : 'Bosnie-Herzégovine',
        BB : 'Barbade',
        BD : 'Bangladesh',
        BE : 'Belgique',
        BF : 'Burkina Faso',
        BG : 'Bulgarie',
        BH : 'Bahreïn',
        BI : 'Burundi',
        BJ : 'Bénin',
        BM : 'Bermudes',
        BN : 'Brunéi Darussalam',
        BO : 'Bolivie',
        BR : 'Brésil',
        BS : 'Bahamas',
        BT : 'Bhoutan',
        BV : 'Île Bouvet',
        BW : 'Botswana',
        BY : 'Biélorussie',
        BZ : 'Belize',
        CA : 'Canada (excepté Québec)',
        CF : 'République centrafricaine',
        CG : 'Congo',
        CH : 'Suisse',
        CI : "Côte d'Ivoire",
        CK : 'Îles Cook',
        CL : 'Chili',
        CM : 'Cameroun',
        CN : 'Chine',
        CO : 'Colombie',
        CR : 'Costa Rica',
        CU : 'Cuba',
        CV : 'Cap-Vert',
        CY : 'Chypre',
        CZ : 'République tchèque',
        DE : 'Allemagne',
        DJ : 'Djibouti',
        DK : 'Danemark',
        DM : 'Dominique',
        DO : 'République Dominicaine',
        DZ : 'Algérie',
        EC : 'Équateur',
        EE : 'Estonie',
        EG : 'Égypte',
        EH : 'Sahara occidental',
        ER : 'Érythrée',
        ES : 'Espagne',
        ET : 'Éthiopie',
        FI : 'Finlande',
        FJ : 'Fidji',
        FK : 'Îles Malouines',
        FM : 'Micronésie',
        FO : 'Îles Féroé',
        FR : 'France',
        GA : 'Gabon',
        GB : 'Royaume-Uni',
        GD : 'Grenade',
        GE : 'Géorgie',
        GF : 'Guyane française',
        GH : 'Ghana',
        GI : 'Gibraltar',
        GL : 'Groenland',
        GM : 'Gambie',
        GN : 'Guinée',
        GP : 'Guadeloupe (française)',
        GQ : 'Guinée équatoriale',
        GR : 'Grèce',
        GS : 'Géorgie du Sud-et-les îles Sandwich du Sud',
        GT : 'Guatemala',
        GU : 'Guam (États-Unis)',
        GW : 'Guinée Bissau',
        GY : 'Guyane',
        HK : 'Hong Kong',
        HM : 'Îles Heard-et-MacDonald',
        HN : 'Honduras',
        HR : 'Croatie',
        HT : 'Haïti',
        HU : 'Hongrie',
        ID : 'Indonésie',
        IE : 'Irlande',
        IL : 'Israël',
        IN : 'Inde',
        IO : "Territoire britannique de l'océan Indien",
        IQ : 'Irak',
        IR : 'Iran',
        IS : 'Islande',
        IT : 'Italie',
        JM : 'Jamaïque',
        JO : 'Jordanie',
        JP : 'Japon',
        KE : 'Kenya',
        KG : 'Kirghizistan',
        KH : 'Cambodge',
        KI : 'Kiribati',
        KM : 'Comores',
        KN : 'Saint-Christophe-Niévès-Anguilla',
        KP : 'Corée du Nord',
        KR : 'Corée du Sud',
        KW : 'Koweït',
        KY : 'Îles Caïmans',
        KZ : 'Kazakhstan',
        LA : 'Laos',
        LB : 'Liban',
        LC : 'Sainte-Lucie',
        LI : 'Liechtenstein',
        LK : 'Sri Lanka',
        LR : 'Liberia',
        LS : 'Lesotho',
        LT : 'Lituanie',
        LU : 'Luxembourg',
        LV : 'Lettonie',
        LY : 'Libye',
        MA : 'Maroc',
        MC : 'Monaco',
        MD : 'Moldavie',
        ME : 'Monténégro',
        MG : 'Madagascar',
        MH : 'Îles Marshall',
        MK : 'Macédoine',
        ML : 'Mali',
        MM : 'Myanmar',
        MN : 'Mongolie',
        MO : 'Macao',
        MP : 'Îles Mariannes du Nord',
        MQ : 'Martinique (française)',
        MR : 'Mauritanie',
        MS : 'Montserrat',
        MT : 'Malte',
        MU : 'Maurice',
        MV : 'Maldives',
        MW : 'Malawi',
        MX : 'Mexique',
        MY : 'Malaisie',
        MZ : 'Mozambique',
        NA : 'Namibie',
        NC : 'Nouvelle-Calédonie (française)',
        NE : 'Niger',
        NF : 'Île Norfolk',
        NG : 'Nigéria',
        NI : 'Nicaragua',
        NL : 'Pays-Bas',
        NO : 'Norvège',
        NP : 'Népal',
        NR : 'Nauru',
        NU : 'Niue',
        NZ : 'Nouvelle-Zélande',
        OM : 'Oman',
        PA : 'Panama',
        PE : 'Pérou',
        PF : 'Polynésie (française)',
        PG : 'Papouasie-Nouvelle-Guinée',
        PH : 'Philippines',
        PK : 'Pakistan',
        PL : 'Pologne',
        PM : 'Saint-Pierre-et-Miquelon',
        PN : 'Île Pitcairn',
        PR : 'Porto Rico',
        PT : 'Portugal',
        PW : 'Palau',
        PY : 'Paraguay',
        QA : 'Qatar',
        RE : 'Réunion (française)',
        RO : 'Roumanie',
        RS : 'Serbie',
        RU : 'Fédération de Russie',
        RW : 'Rwanda',
        SA : 'Arabie Saoudite',
        SB : 'Îles Salomon',
        SC : 'Seychelles',
        SD : 'Soudan',
        SE : 'Suède',
        SG : 'Singapour',
        SH : 'Sainte-Hélène',
        SI : 'Slovénie',
        SK : 'République slovaque',
        SL : 'Sierra Leone',
        SM : 'Saint-Marin',
        SN : 'Sénégal',
        SO : 'Somalie',
        SR : 'Suriname',
        ST : 'Sao Tomé-et-Principe',
        SV : 'Salvador',
        SY : 'Syrie',
        SZ : 'Swaziland',
        TC : 'Îles Turques-et-Caïques',
        TD : 'Tchad',
        TF : 'Terres australes françaises',
        TG : 'Togo',
        TH : 'Thaïlande',
        TJ : 'Tadjikistan',
        TK : 'Tokelau',
        TM : 'Turkménistan',
        TN : 'Tunisie',
        TO : 'Tonga',
        TR : 'Turquie',
        TT : 'Trinité-et-Tobago',
        TV : 'Tuvalu',
        TW : 'Taïwan',
        TZ : 'Tanzanie',
        UA : 'Ukraine',
        UG : 'Ouganda',
        UM : 'Îles mineures éloignées des États-Unis',
        US : 'États-Unis',
        UY : 'Uruguay',
        UZ : 'Ouzbékistan',
        VA : 'État de la Cité du Vatican',
        VC : 'Saint-Vincent-et-les-Grenadines',
        VE : 'Venezuela',
        VG : 'Îles Vierges britanniques',
        VI : 'Îles Vierges des États-Unis',
        VN : 'Vietnam',
        VU : 'Vanuatu',
        WF : 'Territoire des îles Wallis-et-Futuna',
        WS : 'Samoa',
        XK : 'Kosovo',
        YE : 'Yémen',
        YT : 'Mayotte',
        ZA : 'Afrique du Sud',
        ZM : 'Zambie',
        ZW : 'Zimbabwe',
    },
    dateTime : {
        january : 'Janvier',
        february : 'Février',
        march : 'Mars',
        april : 'Avril',
        may : 'Mai',
        june : 'Juin',
        july : 'Juillet',
        august : 'Août',
        september : 'Septembre',
        october : 'Octobre',
        november : 'Novembre',
        december : 'Décembre',
        month : 'Mois',
        day : 'Jour',
        year : 'Année',
        '2_MIN' : '2 minutes',
        '20_MIN' : '20 minutes',
        '2_HOURS' : '2 heures',
        '24_HOURS' : '24 heures',
        '3_DAY' : '3 jours',
        A_FEW_MINUTES : 'quelques minutes',
        A_FEW_HOURS : 'quelques heures',
        A_FEW_DAYS : 'quelques jours',
    },
    dischargeDate : 'Date de sortie',
    emailAddress : 'Adresse électronique',
    emailExplanation : 'Nécessaire pour vous envoyer votre code unique',
    schoolName : '', // N/A
    phoneNumber : 'Numéro de téléphone portable',
    error : 'Erreur',
    limitExceededError : 'Limite de vérification dépassée',
    firstName : 'Prénom',
    howDoesReviewWork : "Comment se déroule l'évaluation?",
    howDoesVerifyingWork : 'Comment se déroule la vérification?',
    informationTransferredToUS : 'Vos informations seront transférées aux États-Unis et seront traitées conformément à la politique de confidentialité de SheerID',
    lastName : 'Nom',
    loading : 'chargement...',
    locales : {
        'en-US' : 'Anglais',
        fr : 'Français',
        nl : 'Néerlandais',
        'fr-CA' : 'Français (canadien)',
        de : 'Allemand',
        it : 'Italien',
        es : 'Espagnol',
        'en-AU' : 'Anglais (Australie)',
        'en-GB' : 'Anglais (Royaume-Uni)',
        ar : 'Arabe',
        bg : 'Bulgare',
        'zh-HK' : 'Chinois (Hong Kong)',
        zh : 'Chinois (traditionnel)',
        hr : 'Croate',
        cs : 'Tchèque',
        da : 'Danois',
        fi : 'Finlandais',
        el : 'Grec',
        iw : 'Hébreu',
        hu : 'Hongrois',
        is : 'Islandais',
        id : 'Indonésien',
        ja : 'Japonais',
        ko : 'Coréen',
        lt : 'Lituanien',
        ms : 'Malais',
        no : 'Norvégien',
        pl : 'Polonais',
        'pt-BR' : 'Portugais (Brésil)',
        pt : 'Portugais',
        ro : 'Roumain',
        ru : 'Russe',
        sr : 'Serbe',
        sk : 'Slovaque',
        sl : 'Slovène',
        'es-ES' : 'Espagnol (Espagne)',
        sv : 'Suédois',
        tr : 'Turc',
    },
    militaryStatus : 'Statut militaire',
    noOptions : 'Aucune option',
    personalInformation : 'Informations personnelles',
    personalOrSchoolIsFine : 'Le courriel personnel ou scolaire est accepté',
    postalCode : 'Code postal',
    poweredBy : 'Services de vérification fournis par SheerID',
    requiredFields : 'Tous les champs sont obligatoires',
    school : 'École',
    sheeridFaqs : 'FAQ de SheerID',
    studentInfoShared : 'Les informations saisies dans ce formulaire web seront utilisées à des fins de vérification. Les informations seront partagées avec {companyName}. ',
    universityName : 'Nom de l’université',
    verifyAndContinue : 'Vérifier et continuer',
    verificationPurposesOnly : 'Utilisé uniquement à des fins de vérification',
    verifyMyStudentStatus : 'Vérifier mon statut d’étudiant',
    verifyMyTeacherStatus : "Vérifier mon statut d'enseignant",
    verifyMyMilitaryStatus : 'Vérifier mon statut de militaire',
    verifyMyMedicalProfessionalStatus : 'CONTINUER',
    verifyMyEmploymentStatus : 'Vérifier mon statut d’employé',
    status : 'Statut',
    VETERAN : 'Vétéran',
    MILITARY_RETIREE : 'Retraité militaire',
    RESERVIST : 'Réserviste',
    ACTIVE_DUTY : 'Service actif',
    MILITARY_FAMILY : 'Militaire à charge enregistré',
    FIREFIGHTER : 'Pompier',
    POLICE : 'Police',
    EMT : 'EMT',
    organization : 'Organisation',
    verifyMyFirstResponderStatus : 'Vérifier mon statut de premier intervenant',
    firstResponderInfoShared : 'Les informations saisies ici seront utilisées à des fins de vérification',
    militaryInfoShared : 'Les informations saisies ici seront utilisées à des fins de vérification.',
    tryAgain : 'Réessayez',
    errorId : {
        internalServerError : 'Erreur interne du serveur',
        noProgram : 'Aucun programme trouvé',
        noVerification : 'Aucune vérification trouvée',
        expiredProgram : "Ce lien n'est plus accessible",
        invalidProgram : 'Programme non valide',
        invalidStep : 'Étape non valide',
        invalidMilitaryStatus : 'Statut militaire non valide',
        invalidFirstResponderStatus : 'Statut de premier intervenant non valide',
        invalidOrganization : 'Vous devez sélectionner une organisation dans la liste',
        invalidFirstName : 'Prénom non valide',
        invalidLastName : 'Nom non valide',
        invalidBirthDate : 'Date de naissance non valide',
        invalidEmail : 'Courriel non valide',
        invalidPhoneNumber : 'Numéro de téléphone portable non valide',
        invalidPostalCode : 'Code postal non valide',
        invalidAddress : 'Adresse non valide',
        invalidCity : 'Ville non valide',
        invalidState : 'État non valide',
        underagePerson : 'Les personnes âgées de moins de 16 ans ne sont pas éligibles à cette offre.',
        noRemainingRewardCodes : 'Désolé, cette offre est fermée et nous ne pouvons pas vous vérifier pour le moment. Veuillez réessayer plus tard.',
        outsideAgePerson : 'Âge en dehors de la plage autorisée',
        futureBirthDate : 'Date de naissance future',
        unsupportedDocMimeType : 'Un ou plusieurs formats de fichiers ne sont pas pris en charge',
        invalidFileSizeEmpty : 'Un ou plusieurs fichiers sont vides',
        invalidFileSizeMax : 'Un ou plusieurs fichiers sont trop volumineux (max. : 10 Mo)',
        invalidNumberOfFiles : 'Nombre maximal de fichiers dépassé (max. : 5)',
        invalidDocUploadToken : 'Le jeton de téléchargement du document fourni n’est pas valide',
        verificationLimitExceeded : 'Nous sommes ravis de votre enthousiasme, mais il semble que vous ayez déjà bénéficié ou tenté de bénéficier de cette offre.',
        fraudRulesReject: 'Nous sommes ravis de votre enthousiasme, mais il semble que vous ayez déjà bénéficié ou tenté de bénéficier de cette offre.',
        apiRateLimitExceeded : 'Impossible de traiter votre demande pour le moment, veuillez réessayer plus tard',
        docReviewLimitExceeded : 'Limite d’examen du document dépassée',
        maxMetadataValuesExceeded : 'Nombre maximal de valeurs de métadonnées dépassé',
        maxMetadataLengthExceeded : 'Longueur maximale de la valeur des métadonnées dépassée',
        unknownError : 'Erreur inconnue',
        invalidRequest : 'Requête non valide',
        invalidApiToken : 'Le jeton de l’API fourni était non valide ou vide',
        simulatedError : 'Ceci est une erreur simulée',
        notFound : 'Introuvable',
        unauthorizedDomain : 'Domaine non autorisé',
        invalidCountry : 'Pays non valide',
        invalidMemberId : "Numéro d'identification non valide",
    },
    step : {
        personalInfo : {
            title : 'VÉRIFIEZ VOS COORDONNÉES',
            subtitle : 'Si vous êtes un professionnel de la santé agréé, veuillez remplir le formulaire ci-dessous.',
            howDoesVerifyingWorkDetails : `Pour pouvoir bénéficier de cette offre, vous devez (1) être un professionnel de la santé actuellement autorisé à exercer aux États-Unis
                    et (2) être membre d'une unité éligible de la profession médicale. Les unités éligibles sont indiquées
                    dans le sélecteur de statut de ce formulaire.<br><br>{company} utilise SheerID, partenaire de confiance, pour vérifier que vous êtes un professionnel médical.
                    SheerID ne collecte que des informations permettant de vérifier votre éligibilité.
                    Des informations ou des documents supplémentaires peuvent être demandés.`,
            tryAgain : {
                title : 'Vérifiez votre nom, votre code postal, votre date de naissance et votre organisation',
                subtitle : 'Votre nom complet, le nom de votre organisation, votre code postal et votre date de naissance doivent correspondre à ce qui est enregistré auprès de votre organisme de délivrance des permis.',
            },
        },
        docUpload : {
            title : 'TÉLÉVERSEZ DE LA DOCUMENTATION',
            subtitle : 'Les documents seront examinés dans quelques minutes par le personnel de SheerID, un partenaire de confiance.',
            acceptableUploadExamples : 'Voici quelques exemples acceptables :',
            acceptedTypes : 'Le fichier doit être au format .jpg .jpeg .png .pdf .gif ou .bmp',
            addFile : 'Ajouter le fichier',
            cancelButtonLabel : 'Annuler',
            fileInstructions : 'Drag &amp; déposez vos fichiers ici ou <span class="sid-dropzone-wrap--link">browse</span>',
            footer : '',
            submitButtonLabel : 'Continuer',
            rejectedSubtitle : 'Nous n’avons pas pu confirmer votre éligibilité en raison de :',
            howDoesVerifyingWorkDetails : `La révision des documents est gérée par SheerID, partenaire de confiance spécialisé dans la vérification
                    des professionnels de la santé.<br><br>Les documents ne sont utilisés que pour s'assurer que votre statut de professionnel de la santé est
                    à jour et seront définitivement supprimés une fois l'examen terminé. Ces informations ne seront pas partagés avec {companyName}.`,
            uploadInstructions : 'Téléversez un document officiel qui indique :',
            rejectionReasons : {
                DOCUMENT_UNREADABLE : "Le document que vous avez soumis était illisible en raison de la mauvaise qualité de l'image. Assurez-vous d’avoir une image claire, nette et lisible, puis essayez à nouveau de la soumettre.",
                DOCUMENT_PASSWORD_PROTECTED : "Nous n'acceptons pas de documents protégés par mot de passe.",
                DOCUMENT_LIKELY_FRAUD : "Le document que vous avez soumis est insuffisant pour établir l'admissibilité à cette offre.",
                DOCUMENT_UNSUPPORTED : 'Le document que vous avez soumis ne figure pas sur la liste des types de documents acceptés.',
                DOCUMENT_HANDWRITTEN : "Nous n'acceptons pas les documents manuscrits.",
                MISSING_INFORMATION : 'Le document que vous avez soumis ne fournit pas toutes les informations nécessaires pour déterminer votre admissibilité à cette offre.',
                MISSING_INFORMATION_PERSON_NAME : 'Il manque un prénom et/ou un nom de famille au document que vous avez soumis.',
                MISSING_INFORMATION_ORGANIZATION_NAME : "Le document que vous avez soumis ne comprend le nom d'aucune organisation qui atteste de votre lien avec cette organisation.",
                DOCUMENT_EXPIRED : 'Le document que vous avez soumis a expiré.',
                DOCUMENT_OUTDATED : "La date d'émission du document que vous avez soumis est manquante ou trop ancienne.",
                MISMATCH_PERSON_NAME : 'Les informations sur le document que vous avez soumis ne correspondent pas au prénom et/ou au nom de famille soumis dans le formulaire de vérification.',
                MISMATCH_ORGANIZATION : "Le nom de l'organisation sur le(s) document(s) que vous avez soumis ne correspond pas à celui mentionné dans le formulaire de vérification.",
                MISMATCH_STATUS : 'Le statut du document que vous avez soumis ne correspond pas à celui mentionné dans votre formulaire de vérification.',
                INELIGIBLE_ORGANIZATION : "L'organisation sur le document que vous avez soumis n'est pas éligible à cette offre.",
                MISSING_INFORMATION_UNIVERSITY_ENROLLMENT : 'Le document que vous avez soumis ne prouve pas votre inscription à la session actuelle.',
                INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT : 'Les élèves du secondaire ne sont pas éligibles à cette offre.',
                MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES : 'Le document que vous avez soumis ne montre aucune affiliation à une unité éligible des forces armées américaines.',
                MISMATCH_COMPANY_NAME_OR_ADDRESS : "Le nom ou l'adresse de l'entreprise figurant dans votre document ne correspond pas à ce que vous avez indiqué sur le formulaire de vérification.",
                PAYSTUB_OUTDATED_LAST_30_DAYS : 'Veuillez télécharger un talon de chèque de paie émis au cours des 30 derniers jours.',
                MISSING_INFORMATION_BIRTHDATE : 'Il manque la date de naissance sur le document que vous avez soumis, ou vous êtes inéligible à cette offre du fait de votre âge.',
                MISMATCH_BIRTHDATE : 'La date de naissance sur le document que vous avez soumis ne correspond pas à celle mentionnée dans le formulaire de vérification.',
                DOCUMENT_OUTDATED_FACULTY : 'Le document que vous avez soumis n’est pas une attestation d’emploi valable pour l’année universitaire en cours.',
                MISSING_OR_MISMATCH_JOB_TITLE : 'L’intitulé du poste sur le document que vous avez soumis est manquant ou ne correspond pas à celui que vous avez entré sur le formulaire de vérification.',
                OTHER_CONTACT_US : "Nous rencontrons des difficultés dans la vérification de votre éligibilité à l'offre. Pour toute aide, veuillez contacter le service client SheerID à l'adresse suivante : customerservice@sheerid.com",
                PERSON_FIELD_MISMATCH : "Un champ du document fourni ne correspond pas à l'information fournie sur le formulaire de vérification.",
            },
            uploadInfo : {
                fullName : 'Votre nom complet',
                student : {
                    enrollmentDate : 'Date prouvant l’inscription pour la session en cours (ou pour les 3 derniers mois)',
                    school : 'Votre école',
                },
                teacher : {
                    currentSchoolYear : "Une date dans l'année scolaire en cours",
                    school : 'Votre école',
                },
                military : {
                    currentAffiliation : 'Votre affiliation actuelle avec les services armés',
                    dischargeDate : 'Votre date de sortie (le cas échéant)',
                    serviceBranch : 'Votre branche de service',
                    uploadInstructionsDependent : 'Veuillez télécharger un document qui indique clairement vos nom, prénom, dates de validité et statut',
                },
                age : {
                    birthDate : 'Votre date de naissance',
                },
                senior : {
                    birthDate : 'Votre date de naissance',
                },
                firstResponder : {
                    currentAffiliation : 'Votre affiliation actuelle avec cette organisation',
                    organization : 'Votre organisation',
                },
                medical : {
                    status : 'Votre statut de professionnel de la santé',
                    validDate : 'Une date de validité en cours',
                },
                employment : {
                    company : 'Votre entreprise',
                    currentAffiliation : 'Votre affiliation actuelle à cette entreprise',
                },
            },
            acceptableUploads : {
                student : {
                    idCard : 'Carte d’identité scolaire avec date d’expiration',
                    classSchedule : 'Horaire des cours',
                    tuitionReceipt : 'Reçu de scolarité',
                },
                teacher : {
                    idCard : "Carte d'identité d'enseignant avec date de validité",
                    payStub : 'Talon de chèque de paie des 60 derniers jours',
                },
                senior : {
                    birthCertificate : 'Votre acte de naissance',
                    driversLicense : 'Votre permis de conduire',
                    passport : 'Votre passeport',
                    stateId : "Votre carte d'identité émise par l'État",
                },
                military : {
                    activeDuty : 'Tout document prouvant que vous êtes actuellement en service actif pendant 30 jours ou plus en vertu du titre 10',
                    veteran : 'Tout document prouvant que vous avez rempli les conditions du service militaire et que vous avez été libéré honorablement',
                    reservistA : 'Tout document attestant que vous êtes actuellement en service dans la Garde nationale ou dans une composante de réserve des forces armées américaines',
                    retiree : 'Tout document prouvant que vous êtes un retraité des forces armées américaines',
                    dependent : 'Tout document prouvant que vous êtes un Militaire à charge enregistré',
                },
                medical : {
                    licenseCertificate : 'Certificat de licence',
                    idCard : "Carte d'identité d'infirmier/infirmière avec date d'expiration",
                    photoPayStub : "Carte d'identité avec photo et talon de paye récent",
                },
                employment : {
                    employeeIdCard : "Carte d'identité d'employé",
                    payStub : 'Talon de chèque de paie des 60 derniers jours',
                    officialLetter : 'Une lettre officielle',
                },
            },
        },
        pending : {
            titleCountdown : 'PROCESSUS EN COURS',
            titleReview : 'PROCESSUS EN COURS',
            subtitleCountdown : '',
            subtitle : "SheerID examine vos documents pour confirmer votre statut. Ce traitement peut prendre jusqu'à 20 minutes.",
            subtitle2 : 'Attendez ici ou laissez-nous vous informer du résultat.',
            subtitle3 : 'Vous serez contacté par courriel.',
        },
        success : {
            title : 'SUCCÈS',
            subtitle : 'Vous avez été vérifié. Vous trouverez ci-dessous votre code de récompense que vous pouvez utiliser dès maintenant.',
            copyCouponCode : 'Copier le code du coupon',
            underCoupon: 'Veuillez utiliser ce code pour toutes les offres exclusives ci-dessous.',
            emailNotification : 'Nous vous avons envoyé une copie par courriel afin que vous puissiez utiliser votre nouveau code maintenant ou plus tard. Veuillez chercher le message envoyé par verify@sheerid.com.',
            verificationOnly : "Pour vous assurer que vous avez toutes les possibilités d'utiliser votre réduction, nous vous envoyons également par courriel une copie de votre code et un lien vers le site web de P.volve afin que vous puissiez faire vos achats maintenant ou plus tard. Veuillez consulter un courriel de notre part (verify@sheerid.com) pour tous les détails.",
            redirectTextA : "Pour vous assurer que vous avez toutes les possibilités d'utiliser votre réduction, nous vous envoyons également par courriel une copie de votre code et un lien vers le site web de P.volve afin que vous puissiez faire vos achats maintenant ou plus tard. Veuillez consulter un message de notre part (verify@sheerid.com) pour tous les détails.",
            redirectTextB : "Déjà membre de streaming? Il vous suffit de suivre les mêmes étapes pour vous inscrire à l'abonnement à prix réduit et nous annulerons automatiquement votre abonnement existant.",
            buttonTwo : 'ÉQUIPEMENT + STREAMING – 20% DE RÉDUCTION SUR LA COMMANDE',
        },
        sso : {
            title : 'Choisir la méthode de vérification',
            subtitle : "Certaines informations supplémentaires sont nécessaires pour vérifier votre éligibilité à cette promotion spéciale pour étudiants. Effectuez une vérification à l'aide de l'identifiant unique de votre université ou téléchargez un document de qualification à soumettre à examen",
            subtitle2 : '',
            cancel : '',
            login : "Vérifiez à l'aide de l'authentification unique",
        },
    }
};
